<div class="form-horizontal" ngForm="recordingSettingsForm">

	<div class="form-group row" *ngIf="!hideAutomaticRecordingOption">
		<label class="control-label col-sm-3">{{ 'AutomaticRecording' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<div vbUiRadioBtnGroup [attr.aria-label]="'AutomaticRecording' | translate" *ngIf="!isSidebar">
						<button type="button" name="disableAutoRecording" class="btn btn-white" [(ngModel)]="webcast.disableAutoRecording" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Enabled' | translate }}
						</button>
						<button type="button" class="btn btn-white" name="disableAutoRecording" [(ngModel)]="webcast.disableAutoRecording" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Disabled' | translate }}
						</button>
					</div>
					<span *ngIf="isSidebar">
						{{ (!webcast.disableAutoRecording ? 'UI_Enabled' : 'UI_Disabled') | translate }}
					</span>
				</div>
			</div>
		</div>
	</div>

	<div class="form-group row">
		<label class="control-label col-sm-3">{{ 'Event_Edit_VodAssociateLabel' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<div vbUiRadioBtnGroup [attr.aria-label]="'Event_Edit_VodAssociateLabel' | translate">
						<button type="button" class="btn btn-white" name="autoAssociateVod" [(ngModel)]="webcast.autoAssociateVod" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Enabled' | translate }}
						</button>
						<button type="button" class="btn btn-white" name="autoAssociateVod" [(ngModel)]="webcast.autoAssociateVod" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Disabled' | translate }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="form-group row">
		<label class="control-label col-sm-3">{{ 'Event_Edit_VodRedirectLabel' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<div vbUiRadioBtnGroup [attr.aria-label]="'Event_Edit_VodRedirectLabel' | translate">
						<button type="button" class="btn btn-white" name="redirectEnabled" [(ngModel)]="webcast.redirectVod" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Enabled' | translate }}
						</button>
						<button type="button" class="btn btn-white" name="redirectEnabled" [(ngModel)]="webcast.redirectVod" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Disabled' | translate }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="form-group row" [ngClass]="(form?.control?.get('uploaderUser')?.pristine
			|| form?.control?.get('uploaderUser')?.valid)
			? 'required' : ''">
		<label *ngIf="isNotRunning" class="control-label col-sm-3">{{ 'Event_Edit_Uploader' | translate }}</label>
		<div class="col-sm-9">
			<div class="row" *ngIf="isNotRunning">
				<div class="col-md-6 col-sm-9">
					<span class="help-block">{{ 'Event_Edit_SelectUploaderHeading' | translate }}</span>
				</div>
			</div>
			<div class="row" *ngIf="isNotRunning">
				<div class="col-md-6 col-sm-9">
					<ng-template #accessEntityOptionRow let-item="item" let-insight="insight">
						<access-entity-option-row [item]="item" [insight]="insight"></access-entity-option-row>
					</ng-template>

					<ng-template #accessEntityAssignedRow let-item="item" let-insight="insight">
						<access-entity-assigned-row [item]="item" [insight]="insight"></access-entity-assigned-row>
					</ng-template>
					<insight class="insight-listing" name="uploaderUser" #uploaderUser="ngModel" required [attr.aria-label]="'Event_Private_Attendees' | translate" [insightOptions]="accessControlInsightOptions" [(ngModel)]="webcast.recordingUploaderUsers" [vbMaxLength]="1" [optionTemplate]="accessEntityOptionRow" [assignedTemplate]="accessEntityAssignedRow">
					</insight>
					<span class="required-field"></span>
				</div>


				<div class="margin-left-16 col-md-7 col-sm-9" role="alert" vbUiErrorMessage *ngIf="uploaderUser.invalid">
					@if (uploaderUser.errors.required) {
						{{ 'ThisFieldIsRequired' | translate }}
					} @else if (uploaderUser.errors.vbMaxLength) {
						{{ 'Event_RecordingUploaderCountError' | translate }}
					}
				</div>
			</div>
		</div>
	</div>

	<vb-ui-horizontal-form-group>
		<label for="preRollVideo" #uiLabel>
			{{ 'Event_Recording_PreRoll' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Recording_PreRoll_Help' | translate">
			</vb-ui-tooltip>
		</label>
		<vb-ui-video-preview-select id="preRollVideo" #preRollVideo="ngModel" uiControl [attr.aria-label]="'Event_Recording_PreRoll' | translate" class="vb-input-field" name="preRollVideo" [(ngModel)]="webcast.preRollVideo" [searchQuery]="videoSearchLoader">
		</vb-ui-video-preview-select>
		@if(preRollVideo.invalid) {
			<div role="alert" vbUiErrorMessage uiValidation>
				@if(preRollVideo.errors.videoSourceInvalid) {
					{{ 'Event_Recording_UnsupportedForSource' | translate }}
				}
			</div>
			}
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group>
		<label for="postRollVideo" #uiLabel>
			{{ 'Event_Recording_PostRoll' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Recording_PostRoll_Help' | translate">
			</vb-ui-tooltip>
		</label>
		<vb-ui-video-preview-select id="postRollVideo" #postRollVideo="ngModel" uiControl [attr.aria-label]="'Event_Recording_PostRoll' | translate" class="vb-input-field" name="postRollVideo" [(ngModel)]="webcast.postRollVideo" [searchQuery]="videoSearchLoader">
		</vb-ui-video-preview-select>
		@if(postRollVideo.invalid) {
		<div role="alert" vbUiErrorMessage uiValidation>
			@if(postRollVideo.errors.videoSourceInvalid) {
				{{ 'Event_Recording_UnsupportedForSource' | translate }}
			}
		</div>
		}
	</vb-ui-horizontal-form-group>
</div>
